import { basenameFromUrl, stripStoragePrefix } from '../../utils/attachments';

/**
 * Open a stored B2B document in a new tab, where the browser's own viewer
 * offers the download — the same way the rest of the terminal hands over
 * labels, manifests and invoices. An `<a download>` would be ignored anyway:
 * the files live on S3, a different origin.
 */
export const openB2BDocument = (url) => {
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
};

/** The file's own name, without the uniqueness prefix storage added. */
export const b2bDocumentFileName = (url) => stripStoragePrefix(basenameFromUrl(url));
